export const mru = <T>(
  newItem: T,
  items: T[],
  count: number,
  isEqual: (a: T, b: T) => boolean = (a, b) => a === b,
): T[] => {
  return [newItem]
    .concat(items.filter((item) => !isEqual(item, newItem)))
    .slice(0, count);
};

// https://stackoverflow.com/questions/43118692/typescript-filter-out-nulls-from-an-array
export const notNullOrUndefined = <TValue>(
  value: TValue | null | undefined,
): value is TValue => {
  return value !== null && value !== undefined;
};

export function wrap<T>(value: T | T[] | undefined) {
  if (typeof value === "undefined") {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}
